import script from "./CustomerSatisfaction.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSatisfaction.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSatisfaction.vue?vue&type=style&index=0&id=32077484&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32077484"]])

export default __exports__